import React from 'react';
import coverImg from './go_ham_cover.png'
import user1 from './user1.png'
import ringFit from './ringfit.png'
import user2_1 from './user2_1.png'
import user2_2 from './user2_2.png'
import messenger from './messenger.svg.webp'
import pear from './pear.png'
import myFitnessPal from './my-fitness-pal.png'
import storyboard1 from './storyboard1.png'
import storyboard2 from './storyboard2.png'
import storyboard3 from './storyboard3.png'
import storyboard4 from './storyboard4.png'
import lofiPrototype from './lo-fi-prototype.png'
import sunflowerSeed from './sunflower_seed.png'
import hifiPrototype1 from './hifi-prototype-1.png'
import hifiPrototype2 from './hifi-prototype-2.png'
import hifiPrototype3 from './hifi-prototype-3.png'
import hifiPrototypeEvaluation from './hi-fi-evaluation.png'
import './index.sass'
import ProjectContentContainer from "../../../components/ProjectContentContainer";
import {Grid, useMediaQuery, useTheme} from "@mui/material";
import WordCard from "../../../components/WordCard";
import {MoveToTopOnMount} from "../../../utils/pageScroll";
import Head from "../../../components/Head";
import engagementMap from "../../../assets/images/engagementMap.png";
import ProjectRecord from "../../../components/ProjectRecord";
import standUpReminder from "../stand_up_reminder/stand-up-cover-bg.png";
import bookCover1 from "../book_cover/book_cover1_thumb.png";

const GridContainerEngagementMap = ({children, sx}) => (
    <Grid container spacing={'2rem'} sx={sx}>
        {children}
    </Grid>
)

const FutureWorkCard = ({children}) => (
    <WordCard bgColor={'#FFFBF0'}>
        {children}
    </WordCard>
)

function Index({cursor}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <div>
            <Head
                title={'GO HAM!'}
                desc={'Exercising app re-establishing the Columbia community during COVID-19 through human interaction and gamification.'}
            />
            <MoveToTopOnMount />

            <div className={isMobile ? 'go_ham__cover_mobile' : "go_ham__cover"}>
                <img
                    src={coverImg}
                    alt={'Engagement Map used on a laptop for instructors and on mobile for students'}
                />
                {!isMobile && (
                    <h1>
                        <div>
                            GO HAM!&nbsp;
                            <span>
                                is an exercising app with emphasis on spontaneous human interaction through
                                gamification for students in quarantine.
                            </span>
                        </div>
                    </h1>
                )}
            </div>

            <ProjectContentContainer>
                {isMobile && (
                    <h1 className={'go_ham__title'}>
                        GO HAM!&nbsp;
                        <span className={'go_ham__title__regular'}>
                            is an exercising app with emphasis on spontaneous human interaction through
                            gamification for students in quarantine.
                        </span>
                    </h1>
                )}

                {/*Intro*/}
                <GridContainerEngagementMap sx={{marginTop: '2rem', marginBottom: '4rem'}}>
                    <Grid item xs={12} md={6}>
                        <p>
                            <span className="go_ham__content__bold">
                                During quarantine, students are prone to developing sedentary&nbsp;
                            </span>
                            due to the closure of exercise facilities, discouragement of small gatherings,
                            and their limited space in dorms. Thus, it is easy for students to lack
                            the motivation to exercise.
                        </p>
                        <p className="go_ham__content__bold">
                            We wanted to help students find their motivation. Exercise is an essential part of
                            a healthy, balanced life that is too often overshadowed by school stress.
                        </p>
                        <p>
                            Our design solution will encourage motivation through synced exercise video
                            calls and gamification. For example, two friends may schedule a meet up to work
                            out together and follow video instructions together while on the call. If a
                            user wants to have a spontaneous workout and meet other Columbia students,
                            they can visit virtual locations on the game map, each of which would be
                            designated for a different type of exercise. Users can then easily find new
                            friends to workout with while building a community within GO HAM!
                        </p>
                    </Grid>

                    <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />

                    <Grid item xs={12} md={5}>
                        <h2 className={'engagement_map__intro__h2'}>My Role</h2>
                        <p>
                            Contextual inquiry, Ideation, Comparative analysis, Storyboarding, Lo-Fi
                            (paper) and Hi-Fi (Figma) Prototyping, Implementation (HTML, CSS)
                        </p>
                        <p>
                            As a team of 4, we built on top of my individual project.
                        </p>
                    </Grid>
                </GridContainerEngagementMap>

                <h1>Target User Population</h1>
                <GridContainerEngagementMap sx={{marginBottom: '6rem'}}>
                    <Grid item xs={12} md={6}>
                        <p>
                            Our target population is Columbia University students living in small spaces who may
                            be less motivated to exercise due to COVID-19’s impact on student lifestyles.
                        </p>
                    </Grid>

                    <Grid item md={6} sx={{ display: { md: 'block', xs: 'none' } }} />
                </GridContainerEngagementMap>

                {/*Contextual inquiry*/}
                <GridContainerEngagementMap sx={{marginBottom: '6rem'}}>
                    <Grid item xs={12}>
                        <h1>Contextual Inquiry</h1>
                        <h2>User 1</h2>
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12} md={5}>
                                <img
                                    src={user1}
                                    alt={'contextual inquiry with user 1 on zoom'}
                                    className={'go_ham__img'}
                                />
                            </Grid>

                            <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />

                            <Grid item xs={12} md={6}>
                                <p>
                                    22 year old university student in his senior year whose favorite exercise is cycling.
                                </p>
                                <p>
                                    He spends most of his time in his room either studying, playing games, listening
                                    to music, or sleeping
                                </p>
                                <p>
                                    He lives in an apartment style university dorm.
                                </p>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <p>
                            During the observation, he worked and played games on his desktop.
                        </p>
                        <p>
                            Since he is tall, his room was too small for his height to do any exercise.
                        </p>
                        <p>
                            He is fully aware that his current lifestyle combined with his terrible sleep schedule
                            is not a healthy behavior for him and has been telling himself to start exercising.
                        </p>
                    </Grid>

                    <Grid item>
                        <Grid container>
                            <Grid item xs={12} md={6}>
                                <p>
                                    One of the solutions he came up with was to buy the Nintendo Ring Fit Adventure.
                                </p>
                                <p>
                                    He thought that the game made the boring process of exercises fascinating by
                                    fighting against the monsters and demons. He believes that the sense of
                                    accomplishment gained through the reward system of experience points,
                                    leveling up, and possibly sharing on social media was the source of motivation.
                                </p>
                                <p>
                                    While he was able to continue for a week, he quit the game as he saw games
                                    that were more fun and less physical.
                                </p>
                                <p>
                                    He ended the interview by telling me that there is currently no incentive for
                                    him to work out since he does not have to see anyone, nor does he have to
                                    show his face or body during zoom classes.
                                </p>
                                <p>
                                    I learned from this user that he knows that not exercising is unhealthy but,
                                    in reality, is not inclined to work out even if there is a fun gaming component
                                    accompanying it. However, it seems that a sense of accomplishment together
                                    with human interaction was somewhat effective in order for him to start working out.
                                </p>
                            </Grid>

                            <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />

                            <Grid item xs={12} md={5} className={'go_ham__grid_center'}>
                                <img
                                    src={ringFit}
                                    alt={'package of a nintendo switch game, ring fit adventure'}
                                    className={'go_ham__img'}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    {/*User 2*/}
                    <Grid item xs={12}>
                        <h2>User 2</h2>
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12} md={5}>
                                <img
                                    src={user2_1}
                                    alt={'contextual inquiry with user 2 on zoom'}
                                    className={'go_ham__img'}
                                />
                            </Grid>

                            <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />

                            <Grid item xs={12} md={6}>
                                <p>
                                    21 year old university student in his senior year who enjoys playing ping pong.
                                </p>
                                <p>
                                    He was previously a varsity track athlete for three years in college but decided to relax.
                                </p>
                                <p>
                                    He lives in an apartment style university dorm.
                                </p>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <p>
                            His room is also very minimal and most of the space was occupied by the bed, desk,
                            and closet and so he does not have space to walk around. Therefore, his daily
                            routine was very much associated with his desk and bed.
                        </p>
                        <p>
                            He does think of working out but feels lazy due to a lack of motivation.
                        </p>
                    </Grid>

                    <Grid item>
                        <Grid container>
                            <Grid item xs={12} md={6}>
                                <p>
                                    Interestingly, he stopped exercising even though he was a varsity athlete
                                    for the past three years. This was because he did not have any expectations
                                    anymore. When he was an athlete, he was always expected by his coaches and
                                    team mates as well as himself to work out to perform better in his matches and
                                    this is what kept him going.
                                </p>
                                <p>
                                    When I questioned him about his ideal way to exercise, he touched on how much
                                    human interaction was important to make the process fun. He mentioned that
                                    rather than the traditional ways of working out in the gym by himself, he
                                    preferred exercising through playing, for example, frisbee.
                                </p>
                                <p>
                                    I learned that the important thing for continuing exercises is to have a fun
                                    experience and a set routine with human interactions so that you could motivate
                                    each other.
                                </p>
                            </Grid>

                            <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />

                            <Grid item xs={12} md={5}>
                                <img
                                    src={user2_2}
                                    alt={'user 2 stretching in his small dorm room'}
                                    className={'go_ham__img'}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </GridContainerEngagementMap>

                {/*Comparative Analysis*/}
                <GridContainerEngagementMap sx={{marginBottom: '6rem'}}>
                    <Grid item xs={12}>
                        <h1>Comparative Analysis</h1>
                        <h2 className={'go_ham__title__mb_0'}>Messenger</h2>
                    </Grid>

                    {/*Messenger*/}
                    <>
                        <Grid item>
                            <Grid container>
                                <Grid item xs={12} md={5}>
                                    <p>
                                        Messenger is a video conferencing platform through which people can remotely
                                        exercise together.
                                    </p>
                                    <p>
                                        Users can chat and decide that they want to exercise together. They can coordinate
                                        a time and manually mark it in their individual calendars.
                                    </p>
                                    <p>
                                        Within a video call, they can search for exercises online together,
                                        screenshare, and work out synchronously at no time limit.
                                    </p>
                                </Grid>

                                <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />

                                <Grid item xs={12} md={6} className={'go_ham__grid_center'}>
                                    <img
                                        src={messenger}
                                        alt={'icon of the messenger app'}
                                        className={'go_ham__img'}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <h3>Evaluation</h3>
                            <p>
                                Messenger is a poor solution in that for users to exercise together, they may
                                need to coordinate across multiple platforms (e.g. Messenger, calendar,
                                Google / YouTube, timer) This creates a time-consuming hassle.
                            </p>
                            <p>
                                Not a viable or sustainable solution for our sub-problem of motivation. There
                                is no source of motivation unless there is already a dedicated person on the
                                other side.
                            </p>
                        </Grid>
                    </>

                    {/*PEAR*/}
                    <>
                        <Grid item>
                            <h2 className={'go_ham__title__mb_0'}>PEAR - Personal Fitness Coach</h2>
                        </Grid>
                        <Grid item>
                            <Grid container>
                                <Grid item xs={12} md={5}>
                                    <p>
                                        PEAR is a mobile app for exercises with video coaching that keeps track of
                                        your stats and also analyzes data from smartwatches.
                                    </p>
                                    <p>
                                        It has an embedded music player system, PEAR Music, for users with
                                        membership that plays workout music of selected genre.
                                    </p>
                                    <p>
                                        During the workout, there is a video that clearly teaches you what
                                        to do with a countdown timer.
                                    </p>
                                </Grid>

                                <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />

                                <Grid item xs={12} md={6}>
                                    <img
                                        src={pear}
                                        alt={'user interface of pear'}
                                        className={'go_ham__img'}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <h3>Evaluation</h3>
                            <p>
                                The solution is well designed and easy to navigate. However, this solution does
                                not work for users who live in a small space.
                            </p>
                            <p>
                                The other problem is that this app lacks source of motivation and only works
                                for users who are already determined to continue working out.
                            </p>
                        </Grid>
                    </>

                    {/*My fitness pal*/}
                    <>
                        <Grid item>
                            <h2 className={'go_ham__title__mb_0'}>My Fitness Pal</h2>
                        </Grid>
                        <Grid item>
                            <Grid container>
                                <Grid item xs={12} md={5}>
                                    <p>
                                        MyFitnessPal was designed to help people lose weight by promoting healthy eating and exercising.
                                    </p>
                                    <p>
                                        It allows users to keep track of their calorie count, find personalized workouts for their calorie targets, and post their weight loss journeys.
                                    </p>
                                    <p>
                                        It provides users with different options to customize their social feed.
                                    </p>
                                    <p>
                                        Users can share completed workouts or achievements with friends.
                                    </p>
                                    <p>
                                        At the top of the user’s feed, users can see the remaining amount of calories to burn for that day and other stats such as steps, food, and goals.
                                    </p>
                                </Grid>

                                <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />

                                <Grid item xs={12} md={6}>
                                    <img
                                        src={myFitnessPal}
                                        alt={'user interface of my fitness pal'}
                                        className={'go_ham__img'}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <h3>Evaluation</h3>
                            <p>
                                While this is a great app that helps users keep track of their own progress, this application does not serve our target population’s needs (being motivated to work out while under quarantine).
                            </p>
                            <p>
                                While a user can see their friend’s workouts on their newsfeed, the app supports neither joint nor remote workout sessions.
                            </p>
                            <p>
                               Users may only “thumb up” or “thumb down” their friend’s workout, which can limit social interactions within the platform--not to mention be a source of discouragement if a user is given a “thumbs down”
                            </p>
                        </Grid>
                    </>
                </GridContainerEngagementMap>

                {/*Design process*/}
                <GridContainerEngagementMap sx={{marginBottom: '6rem'}}>
                    <Grid item xs={12}>
                        <h1>Design Process / Loops</h1>
                        <h2 className={'go_ham__title__mb_0'}>Loop 1</h2>
                        <h2 className={'go_ham__title__mt_0'}>How do we make users who live in a small space exercise?</h2>
                    </Grid>

                    {/*Loop 1*/}
                    <>
                        <Grid item>
                            <Grid container>
                                <Grid item xs={12} md={2}>
                                    <h3>
                                        Key Insight
                                    </h3>
                                </Grid>

                                <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />

                                <Grid item xs={12} md={9}>
                                    <p>
                                        Through contextual inquiry. I realized that there were many students currently living in small spaces who cannot exercise because the gyms are closed and they do not want to go out since they fear the coronavirus.
                                    </p>
                                    <p>
                                        Not only can they not physically go out to exercise, but also they also lack the motivation to exercise inside their rooms.
                                    </p>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item>
                            <Grid container>
                                <Grid item xs={12} md={2}>
                                    <h3>
                                        Storyboard
                                    </h3>
                                </Grid>

                                <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />

                                <Grid item xs={12} md={9}>
                                    <p>
                                        I started off by searching for ideas through storyboarding. Specifically, I tried to solve the problem of getting users to exercise through different sources of motivation.
                                    </p>
                                    <p>
                                        Some solutions were using human interaction by having two users schedule to meet up and workout together on the app. Another was to use a gaming component where the time spent on the app would increase an avatar’s experience points and the avatars will eventually evolve when you have reached a certain experience point.
                                    </p>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} className={'go_ham__grid_center'}>
                            <img
                                src={storyboard1}
                                alt={'storyboard 1'}
                                className={'go_ham__img'}
                            />
                        </Grid>

                        <Grid item xs={12} className={'go_ham__grid_center'}>
                            <img
                                src={storyboard2}
                                alt={'storyboard 2'}
                                className={'go_ham__img'}
                            />
                        </Grid>

                        <Grid item>
                            <Grid container>
                                <Grid item xs={12} md={2}>
                                    <h3>
                                        Prototyping
                                    </h3>
                                </Grid>

                                <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />

                                <Grid item xs={12} md={9}>
                                    <p>
                                        I made a lo-fi prototype of the first idea as User 2, who was a varsity athlete, told me that human interaction was the key for him to practice persistently.
                                    </p>
                                    <p>
                                        In my prototype, I sketched a basic skeleton of the app with focused on how to schedule a workout between two users and how the actual workout session using a video call would look like.
                                    </p>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <img
                                src={lofiPrototype}
                                alt={'lo-fi prototype on paper'}
                                className={'go_ham__img'}
                            />
                        </Grid>
                    </>

                    {/*Loop 2*/}
                    <>
                        <Grid item xs={12}>
                            <h2 className={'go_ham__title__mb_0'}>Loop 2</h2>
                            <h2 className={'go_ham__title__mt_0'}>How do we motivate users to exercise?</h2>
                        </Grid>

                        <Grid item>
                            <Grid container>
                                <Grid item xs={12} md={2}>
                                    <h3>
                                        Key Insight
                                    </h3>
                                </Grid>

                                <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />

                                <Grid item xs={12} md={9}>
                                    <p>
                                        In order to discover a new solution, I considered encouraging users through the usage of risks.
                                        Specifically, to create a routine and encourage them to work out, I formulated an idea of if the user skips a regularly scheduled workout session, $5 would be automatically withdrawn from their bank account and donated to a political party that they hated.
                                    </p>
                                    <p>
                                        When I presented these ideas to my users, all of them told me that they like the first idea of incorporating a game. One of the reasons why they did not enjoy the latter was because this idea discouraged them from using the app even before they tried it. As my users are not the ones who would be self-motivated to exercise, such risky solution was not appealing to them at all.
                                    </p>
                                    <p>
                                        Additionally, I went into detail about the interface design such as what kind of parameter for stats would encourage the users the most. To test this, I lo-fi prototyped on paper two versions of the stats on the home screen, which were calories and time spent.
                                    </p>
                                    <p>
                                        I learned from my user that calories would be a better metric since time does not directly correspond to the intensity of the exercises and would not be an easy way to gauge how much effort you had spent.
                                    </p>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item>
                            <h3>
                                Prototyping
                            </h3>
                        </Grid>

                        <Grid item xs={12} className={'go_ham__grid_center'}>
                            <iframe
                                title={'hi-fi prototype in figma'}
                                width="800"
                                height="450"
                                style={{maxWidth: '100%'}}
                                src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FnNsFRZwuPFBJ1DlLUfq614%2FWorkOut!%3Fnode-id%3D0%253A1"
                                allowFullScreen
                            />
                        </Grid>

                        <Grid item>
                            <Grid container>
                                <Grid item xs={12} md={2}>
                                    <h3>
                                        Evaluation
                                    </h3>
                                </Grid>

                                <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />

                                <Grid item xs={12} md={9}>
                                    <p>
                                        I tested my prototype with a user for two use cases.
                                    </p>
                                    <p>
                                        One of them was navigating to the video call screen at the time of your scheduled session and the other was to schedule a workout session.
                                        In both cases, it seemed that the user was able to easily navigate through the interface to complete the task.
                                    </p>
                                    <p>
                                        I learned that for users who are less motivated, it is better to encourage them through positivity such as human interaction and gaming rather than enforcing risks on them that raises the barrier for them to use the solution in the first place.
                                    </p>
                                </Grid>
                            </Grid>
                        </Grid>
                    </>

                    {/*Loop 3*/}
                    <>
                        <Grid item xs={12}>
                            <h2 className={'go_ham__title__mb_0'}>Loop 3</h2>
                            <h2 className={'go_ham__title__mt_0'}>Focusing on the challenges</h2>
                        </Grid>

                        <Grid item xs={12}>
                            <h3 className={'go_ham__title__mb_0 go_ham__title__mt_0'}>
                                Finding the right representation for motivation, exercise, and our users
                            </h3>
                        </Grid>

                        <Grid item xs={12}>
                            <p className={'go_ham__title__mt_0'}>
                                Besides the physical restriction of small spaces, we had to come up with extrinsic rewards that would bolster and correlate with intrinsic motivation. We decided on: point level-up systems, positive network effects of social / peer pressure, progress bars, notifications, virtual avatars, and avatar customization.
                            </p>
                            <p>
                                Representing exercise through a smartphone with video call integration is hard. Being watched can feel obtrusive and come with a host of privacy and self-image concerns. Thus, we have chosen to use virtual avatars, which allows users to have a certain amount of protection online and have independence from their physical image.
                            </p>
                        </Grid>

                        <Grid item xs={12}>
                            <h3 className={'go_ham__title__mb_0 go_ham__title__mt_0'}>
                                Initial users of the app will inevitably be individuals, they will not have other users to work out with.
                            </h3>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12} md={9}>
                                    <p className={'go_ham__title__mt_0'}>
                                        A major challenge we realized was user retention. To increase retention rate, we implemented “easter eggs”, or sunflower seeds in our case, on the map so that individual users can click on this to work out alone but with high reward, which leads to faster level ups and customization.
                                    </p>
                                </Grid>

                                <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />

                                <Grid item xs={12} md={2}>
                                    <img
                                        src={sunflowerSeed}
                                        alt={'sunflower seed in go ham'}
                                        className={'go_ham__img'}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item>
                            <Grid container>
                                <Grid item xs={12} md={2}>
                                    <h3>
                                        Storyboard
                                    </h3>
                                </Grid>

                                <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />

                                <Grid item xs={12} md={9}>
                                    <p>
                                        We came up with two new storyboards focusing on how motivation is gained and maintained as well as how individual users would use the app.
                                    </p>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <h4 className={'go_ham__title__mb_0'}>
                                User with a friend
                            </h4>
                        </Grid>

                        <Grid item xs={12}>
                            <img
                                src={storyboard3}
                                alt={'storyboard for a user using the app with a friend'}
                                className={'go_ham__img'}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <h4 className={'go_ham__title__mb_0'}>
                                Individual user
                            </h4>
                        </Grid>

                        <Grid item xs={12}>
                            <img
                                src={storyboard4}
                                alt={'storyboard for a user using the app spontaneously'}
                                className={'go_ham__img'}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <h3 className={'go_ham__title__mb_0'}>
                                Prototyping
                            </h3>
                        </Grid>

                        <Grid item xs={12} className={'go_ham__grid_center'}>
                            <img
                                src={hifiPrototype1}
                                alt={'hi-fi prototype'}
                                className={'go_ham__img go_ham__img_large'}
                            />
                        </Grid>

                        <Grid item>
                            <Grid container>
                                <Grid item xs={12} md={2}>
                                    <h3>
                                        Contextual Inquiry
                                    </h3>
                                </Grid>

                                <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />

                                <Grid item xs={12} md={9}>
                                    <p>
                                        Our first contextual inquiry in this phase was devoted to seeing how well the current Figma appealed to a relevant user in our population. The user was shown the Figma and asked directed questions intended to inform design decisions, such as the following:
                                    </p>
                                    <ol>
                                        <li>
                                            Upon seeing this screen, would the amount of people in one place entice you to join or make you feel shy to join?
                                        </li>
                                        <li>
                                            Would you prefer an anthropomorphic [hamster] avatar or a human one?
                                        </li>
                                    </ol>
                                    <p>
                                        The user provided valuable feedback that encouraged us to trim down the number of ways we represent motivation on the app.
                                        For example, they stated that they were “lost in calories”, meaning that they did not understand the calorie counter on our original home screen. We have since moved towards using experience points as the main unit on our app.
                                    </p>
                                    <p>
                                        They also provided useful input encouraging us to keep our virtual human silhouette avatars, because they stated that human avatars represent “more degrees of freedom”.
                                    </p>
                                    <p>
                                        A second contextual inquiry gave us deeper insight into what our target population values and needs to stay motivated.
                                        The user described their most memorable workout experiences as ones where they had reached a major milestone in their fitness journey, whether it was in weight lifting or running pace, which inspired new features discussed in the next phase.
                                    </p>
                                    <p>
                                        The findings from this inquiry tied back to our focus on motivation, because users found that their motivation to exercise greatly stemmed from personal goals.
                                    </p>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <img
                                src={hifiPrototype2}
                                alt={'hi-fi prototype'}
                                className={'go_ham__img'}
                            />
                        </Grid>

                        <Grid item>
                            <Grid container>
                                <Grid item xs={12} md={2}>
                                    <h3>
                                        Prototyping
                                    </h3>
                                </Grid>

                                <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />

                                <Grid item xs={12} md={9}>
                                    <p>
                                        We created the following additional features: a leaderboard, a comment section, icon customization, a gallery to document progress pictures, and a feature to input exercise goals.
                                    </p>
                                    <p>
                                        We incorporated findings from the contextual inquiry into the Progress Milestones and Progress Pictures features.
                                    </p>
                                    <p>
                                        The “icon customization” feature was designed to showcase the user's level progress and stir up a more competitive spirit amongst users.
                                    </p>
                                    <p>
                                        The user also suggested a comment section that we implemented as our Community Chat. This feature facilitates community building in our virtual gym much as one would in-person by allowing people to exchange advice, discuss workouts, and workout together.
                                    </p>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item>
                            <Grid container>
                                <Grid item xs={12} md={2}>
                                    <h3>
                                        Evaluation
                                    </h3>
                                </Grid>

                                <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />

                                <Grid item xs={12} md={9}>
                                    <p>
                                        One evaluation was conducted with a user experience designer at Google, who gave us a ‘crit’ to suggest improvements as per industry standards. While they enjoyed walking through the experience of our app, they suggested changes for go ham’s look and feel.
                                    </p>
                                    <p>
                                        We standardized our text with iOS / android mobile system font. This is what most popular apps do to minimize friction when users move between different apps on a phone.
                                    </p>
                                    <p>
                                        We also increased the font size of our app. In some frames, we used a size 6 font, whereas the smallest font at her company was 11.
                                    </p>
                                    <p>
                                        Addressing accessibility issues stemming from our usage of yellow and white; this produced low contrast.
                                    </p>
                                    <img
                                        src={hifiPrototypeEvaluation}
                                        alt={'hi-fi prototype evaluation on low color contrast'}
                                        className={'go_ham__img'}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item>
                            <Grid container>
                                <Grid item xs={12} md={2}>
                                    <h3>
                                        Evaluation 2 Wizard of Oz
                                    </h3>
                                </Grid>

                                <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />

                                <Grid item xs={12} md={9}>
                                    <p>
                                        User had an easy time navigating through the app, which means there is low stress in figuring out what to do sustaining the motivation.
                                    </p>
                                    <p>
                                        We also gained affirmation that the newly added progress album and milestones are indeed what our users are looking for. The user mentioned that the progress album is a good way for her to get motivated since she could see her improvements over time.
                                    </p>
                                    <p>
                                        She further continued that even if there was no progress made or she is doing worse, it would still motivate her since she knows that she is not doing well and needs to step up her game and exercise more to progress.
                                    </p>
                                    <p>
                                        One piece of constructive feedback we received was that it would be helpful for users to see which body areas the workout targets to assess whether or not the workout would help meet their goals
                                    </p>
                                    <p>
                                        Another user expressed their concern about profanity and negativity on the exercise community chat. This was an important risk that results from allowing users to communicate on the platform that had not been previously considered. Accordingly, we modified the community chat such that all users can view the chats, but only users who have participated in the exercise can comment to reduce the likelihood of menacing speech.
                                    </p>
                                    <p>
                                        Additionally, all chats have community guidelines and language filters that enforce censoring profanity and the option to report comments for misconduct to remove it from the chat.
                                    </p>
                                    <p>
                                        For the virtual avatars tracking movement in real-time we believe that it would be possible to implement pose tracking on mobile devices using vision networks deployed through the browser and libraries like ml5.js. Certainly, latency issues could crop up, but we could update our virtual avatars at slower frame rates and interpolate the motion--the main point is that people just get the sense t hat they are exercising with others in real time.
                                    </p>
                                    <p>
                                        The map function has now been adjusted to include a virtual location feature, so that when users open up their joint workouts, they are given a virtual background that represents a location near Columbia (ie. Riverside Park). This way, go ham! can foster a sense of place.
                                    </p>
                                    <p>
                                        There are also opportunities to partner with local businesses and existing programs (ie. Dodge), which helps resolve one pain point for content generation / curation.
                                    </p>
                                </Grid>
                            </Grid>
                        </Grid>
                    </>
                </GridContainerEngagementMap>

            </ProjectContentContainer>

            <img
                src={hifiPrototype3}
                alt={'hi-fi prototype for all screens'}
                className={'go_ham__img'}
            />

            <ProjectContentContainer>
                {/*Design solution*/}
                <GridContainerEngagementMap sx={{marginTop: '4rem', marginBottom: '2rem'}}>
                    <Grid item xs={12}>
                        <h1>Design Solution</h1>
                    </Grid>

                    <Grid item xs={12} className={'go_ham__grid_center'}>
                        <iframe
                            title={'video demo of go ham'}
                            src="https://drive.google.com/file/d/1QBHqvb4yeXW58zZd1haGe-FJ6TtOf8Tn/preview"
                            width="100%"
                            height="480"
                            style={{maxWidth: '100%'}}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12} md={5}>
                                <iframe
                                    title={'demo of go ham'}
                                    src="https://codesandbox.io/embed/empty-forest-xezkc?fontsize=14&theme=dark&view=preview"
                                    width='375'
                                    height='850'
                                    style={{maxWidth: '100%'}}
                                    sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
                               />
                            </Grid>

                            <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />

                            <Grid item xs={12} md={6}>
                                <p>
                                    In the Home screen, at certain levels,  users can customize their avatars with sweatbands and belts to motivate and promote competition amongst users.
                                </p>
                                <p>
                                    The Video Call screen shows a split-screen; the top half plays a pre-recorded video of an instructor demonstrating exercises, while the bottom half displays the pair working out. There is also a countdown timer to indicate how much time is left.
                                </p>
                                <p>
                                    When the user wants to find more people to work out with, they can navigate a virtual Map screen, which borrows locations from around Columbia. These locations will be the virtual rooms within which exercises like ‘Cardio’, ‘Yoga’ or ‘Weights’ take place in. Users can check how many other students are online in each location.
                                </p>
                                <p>
                                    The Map Screen has a hamburger icon menu that directs us to the Exercise List view -- a full catalog of workouts users can join, schedule, or comment upon.
                                </p>
                            </Grid>
                        </Grid>
                    </Grid>
                </GridContainerEngagementMap>

                {/*Future work*/}
                <GridContainerEngagementMap sx={{marginBottom: '6rem'}}>
                    <Grid item xs={12}>
                        <h1>Future Work</h1>
                    </Grid>

                    <Grid item xs={12} sx={{marginBottom: {'xs': '2rem'}}}>
                        <FutureWorkCard>
                            Incorporate a more organizational framework for the scheduling feature of the application. The current formatting doesn’t represent the usability heuristic “match between the system and the real world” efficiently.
                        </FutureWorkCard>
                    </Grid>

                    <Grid item xs={12} sx={{marginBottom: {'xs': '2rem'}}}>
                        <FutureWorkCard>
                            Display whether or not the users have the correct form and provide helpful tips to make sure users are targeting the correct muscles. One way we could do this is through highlighting “burn” areas during the workout to emphasize quality over quantity.
                        </FutureWorkCard>
                    </Grid>

                    <Grid item xs={12} sx={{marginBottom: {'xs': '2rem'}}}>
                        <FutureWorkCard>
                            Look into the source of demotivation. Throughout our design process, our primary focus was on how to make users motivated. Now my question is, is there anything in our app that could potentially discourage our users. For example, the invitation system could be improved so that it is not one directional. It may be beneficial if users can post their own schedule and free time by, for instance, synching their Google Calendar.
                        </FutureWorkCard>
                    </Grid>
                </GridContainerEngagementMap>

                {/*Other work*/}
                <GridContainerEngagementMap sx={{marginBottom: '6rem'}}>
                    <Grid item xs={12}>
                        <h1>Other Work</h1>

                        <Grid container spacing={'2rem'}>
                            <Grid item xs={12}>
                                <ProjectRecord
                                    to={'/work/EngagementMap'}
                                    title={'EngagementMap'}
                                    subtitle={'A real-time, location-based, collective, and anonymous feedback system in the classroom'}
                                    desc={'Provides instructors with a glanceable spatial visualization of the classroom to help them understand ' +
                                    'how students are feeling.'}
                                    img={engagementMap}
                                    imgAlt={'smart phone app design of engagement map'}
                                    bgColor={'linear-gradient(127.67deg, rgba(253, 131, 255, 0.2) 60.94%, rgba(255, 139, 139, 0) 76.79%, rgba(255, 255, 255, 0.0252632) 92.97%), #ECF5FF'}
                                    cursor={cursor}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <ProjectRecord
                                    to={'/work/Alexa-Stand-Up-Reminder'}
                                    color={'dark'}
                                    title={'Alexa Stand Up Reminder'}
                                    subtitle={'Sitting for a long time has health concerns and we wanted to help you in a natural way'}
                                    desc={'Reminds you to stand up every 45 minutes and take a break for 5 minutes. During the break, it suggests  fun and relaxing activities!'}
                                    img={standUpReminder}
                                    imgAlt={'logo with alexa'}
                                    bgColor={'linear-gradient(114.74deg, rgba(0, 114, 255, 0.5) 56.88%, rgba(167, 125, 255, 0.265652) 97.5%, rgba(255, 255, 255, 0.0631579) 113.08%), #FF583B'}
                                    cursor={cursor}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <ProjectRecord
                                    to={'/work/book-covers'}
                                    title={'Published Book Covers'}
                                    subtitle={'I designed 2 book covers that were published in Japan'}
                                    img={bookCover1}
                                    imgAlt={'logo of the book cover i designed about inclusive education'}
                                    bgColor={'linear-gradient(127.67deg, rgba(17, 141, 255, 0.3) 60.94%, rgba(217, 242, 249, 0.3) 76.79%, rgba(255, 255, 255, 0.0378947) 92.97%), #F3FFF0'}
                                    cursor={cursor}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </GridContainerEngagementMap>

            </ProjectContentContainer>
        </div>
    );
}

export default Index;